export { default } from './order-product.component';
